class DataService {
  constructor() {
    this.baseUrl = process.env.PUBLIC_URL + '/data';
    this.cache = new Map();
    this.cacheTimeout = 5 * 60 * 1000;
  }

  async fetchData(endpoint) {
    try {
      const response = await fetch(`${this.baseUrl}/${endpoint}.json`);
      if (!response.ok) throw new Error(`Failed to fetch ${endpoint}`);
      return await response.json();
    } catch (error) {
      console.error(`Error fetching ${endpoint}:`, error);
      throw error;
    }
  }

  async getProducts() {
    // const data = await this.fetchData('products');
     const productsRes =  await        fetch('https://server.sohkinflowergifts.com/api/products');
     const data = await productsRes.json();
    return data.products || [];
  }







  getEmptyData(endpoint) {
    const emptyData = {
      'products': { products: [], categories: [], occasions: [] },
      'combos': { combos: [] },
      'addons': { addons: [] },
      'pincodes': { pincodes: [] }
    };
    return emptyData[endpoint] || {};
  }
  async getProductById(id) {
    const products = await this.getProducts();
    return products.find(p => p.id === parseInt(id));
  }

  async getCombos() {
    // const data = await this.fetchData('combos');
    const productsRes =  await        fetch('https://server.sohkinflowergifts.com/api/combos');
     const data = await productsRes.json();
 
    return data.combos || [];
  }

  async getComboById(id) {
    const combos = await this.getCombos();
    return combos.find(c => c.id === parseInt(id));
  }

  async getAddons() {
    const data = await this.fetchData('addons');
    return data.addons || [];
  }

  async getPincodes() {
    // const data = await this.fetchData('pincodes');


        const productsRes =  await        fetch('https://server.sohkinflowergifts.com/api/pincodes');
       
     const data = await productsRes.json();
      console.log(data)
    return data.pincodes || [];
  }

  async checkPincode(pincode) {
    const pincodes = await this.getPincodes();
    return pincodes.find(p => p.pincode === pincode);
  }

  async getCategories() {
    const data = await this.fetchData('products');
    return data.categories || [];
  }

  async getOccasions() {
    const data = await this.fetchData('products');
    return data.occasions || [];
  }

  async getAllProducts() {
    const [products, combos] = await Promise.all([
      this.getProducts(),
      this.getCombos()
    ]);
    return [...products, ...combos];
  }

  async getRelatedProducts(category, excludeId, limit = 4) {
    const products = await this.getProducts();
    return products
      .filter(p => p.category === category && p.id !== excludeId)
      .slice(0, limit);
  }

  async getProductsByCategory(category) {
    const products = await this.getProducts();
    return products.filter(p => p.category === category);
  }

  async getProductsByOccasion(occasion) {
    const products = await this.getAllProducts();
    return products.filter(p => p.occasion?.includes(occasion));
  }

  async searchProducts(query) {
    const allProducts = await this.getAllProducts();
    const searchTerm = query.toLowerCase();
    return allProducts.filter(product => 
      product.name.toLowerCase().includes(searchTerm) ||
      product.description.toLowerCase().includes(searchTerm) ||
      product.tags?.some(tag => tag.toLowerCase().includes(searchTerm))
    );
  }

  async getFilteredProducts(filters = {}) {
    let allProducts = await this.getAllProducts();
    
    if (filters.category) {
      allProducts = allProducts.filter(p => p.category === filters.category);
    }
    
    if (filters.occasion) {
      allProducts = allProducts.filter(p => 
        p.occasion?.includes(filters.occasion)
      );
    }
    
    if (filters.type) {
      allProducts = allProducts.filter(p => p.type === filters.type);
    }
    
    if (filters.minPrice) {
      allProducts = allProducts.filter(p => p.price >= filters.minPrice);
    }
    
    if (filters.maxPrice) {
      allProducts = allProducts.filter(p => p.price <= filters.maxPrice);
    }
    
    if (filters.inStock !== undefined) {
      allProducts = allProducts.filter(p => p.inStock === filters.inStock);
    }
    
    if (filters.sortBy) {
      switch (filters.sortBy) {
        case 'price-low-high':
          allProducts.sort((a, b) => a.price - b.price);
          break;
        case 'price-high-low':
          allProducts.sort((a, b) => b.price - a.price);
          break;
        case 'popularity':
          allProducts.sort((a, b) => (b.rating || 0) - (a.rating || 0));
          break;
        case 'newest':
          allProducts.sort((a, b) => (b.id || 0) - (a.id || 0));
          break;
      }
    }
    
    return allProducts;
  }
}

export default new DataService();